import Image from 'next/image'
import Router from 'next/router'
import { ComponentPropsWithoutRef, useEffect, useState } from 'react'
import { useClient } from 'urql'

import { SignOutMutation } from '@/queries'
import { getAuthentication, logout } from '@/urql'
import { cn } from '@/utils/tw-helpers'
import { graphql } from 'gql.tada'
import { SignUpFlowModal } from '../modal'
import { TopHeaderMenu } from './TopHeaderMenu'

const WebTopHeader_Query = graphql(`
  query WebTopHeader_Query {
    currentUser {
      __typename
      ... on User {
        id
        email
      }
    }
  }
`)

interface WebTopHeaderProps extends ComponentPropsWithoutRef<'header'> {
  title?: string
  showRight?: boolean
}

export const WebTopHeader = (props: WebTopHeaderProps): JSX.Element => {
  const { showRight = true, className, ...rest } = props

  const [isOpenModal, setIsOpenModal] = useState<boolean>(false)
  const [loginId, setLoginId] = useState<string>('')
  const [hasFetchedViewer, setHasFetchedViewer] = useState<boolean>(false)
  const [isReady, setIsReady] = useState<boolean>(false)

  const client = useClient()

  const handleSignOutClick = async function () {
    const refreshToken = getAuthentication()?.refreshToken
    if (!refreshToken) return

    await client.mutation(SignOutMutation, { refreshToken }).toPromise()
    await logout()
  }

  const isAuthenticated = getAuthentication()

  useEffect(() => {
    if (isAuthenticated && !hasFetchedViewer) {
      client
        .query(WebTopHeader_Query, {})
        .toPromise()
        .then((result) => {
          if (result.data?.currentUser?.__typename == 'User') {
            setLoginId(result.data.currentUser.email)
          }
          setHasFetchedViewer(true)
        })
    }

    setIsReady(true)
  }, [isAuthenticated, hasFetchedViewer, client])

  return (
    <>
      <header
        className={cn(
          'flex h-[50px] items-center bg-white px-2 md:h-[60px] md:px-3 lg:h-[70px] lg:px-6',
          className
        )}
        {...rest}
      >
        <div className="md:flex-1">
          <Image
            src="/gApp_logo.svg"
            width={196}
            height={52}
            alt="LogiQlabo"
            className="h-8 w-[120px] md:h-10 md:w-[150px] lg:h-[52px] lg:w-[196px]"
          />
        </div>
        <div className="flex-1">
          {!!props.title && (
            <h2 className="text-center text-lg font-bold text-[#A2A2A2]">
              {props.title}
            </h2>
          )}
        </div>
        <div className="flex flex-1 justify-end">
          {showRight && (
            <>
              {isReady ? (
                isAuthenticated ? (
                  hasFetchedViewer ? (
                    <TopHeaderMenu
                      loginId={loginId}
                      handleSignOutClick={handleSignOutClick}
                    />
                  ) : null
                ) : (
                  <>
                    <button
                      className="g-button g-app-button--primary !h-[44px] w-[130px] !rounded-full !text-sm !shadow-none"
                      onClick={() => setIsOpenModal(true)}
                    >
                      申し込む
                    </button>
                    <button
                      className="g-button g-button--primary ml-[14px] !h-[44px] w-[130px] !rounded-full !text-sm !shadow-none"
                      onClick={() => Router.push('/web/sign_in')}
                    >
                      ログイン
                    </button>
                  </>
                )
              ) : null}
            </>
          )}
        </div>
      </header>

      <SignUpFlowModal
        isOpen={isOpenModal}
        onRequestClose={() => setIsOpenModal(false)}
      />
    </>
  )
}
